import { render, staticRenderFns } from "./ListErrors.vue?vue&type=template&id=c09b4caa&v-show=errors"
import script from "./ListErrors.vue?vue&type=script&lang=js"
export * from "./ListErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports